import { PAX_MANIFEST_FETCH_SEARCH_RESULT } from 'modules/bus/pax-manifest/search/actions/fetchPaxManifestListAction';
import { NOT_INITIALIZED } from 'modules/bus/shared/constants/apiStatuses';
import { LOGOUT_ACTION } from 'modules/general/shared/action/logout';

const initialState = {
  status: NOT_INITIALIZED,
  errorTitle: '',
  errorMessage: '',
  paxManifests: [],
  departureDate: {},
  manifestNumber: '',
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case PAX_MANIFEST_FETCH_SEARCH_RESULT:
      return {
        ...state,
        ...action.payload,
      };
    case LOGOUT_ACTION:
      return initialState;
    default:
      return state;
  }
}
